import { RouterLink } from '@redux-first-router-link';
import { Button } from '@simplywallst/ui-core';
import { useTracking } from 'react-tracking';

export const ButtonNewScreener = () => {
  const { trackEvent } = useTracking();

  return (
    <Button
      as={RouterLink}
      to="/screener/create"
      data-cy-id="my-screeners-new-screener"
      styleType="loud"
      display="block"
      style={{ textAlign: 'center' }}
      onClick={() => {
        trackEvent({ action: 'click', modifier: 'new_screener' });
      }}
    >
      New screener
    </Button>
  );
};
